export enum EmailSettingPropertyName {
  ReceiveWeeklyActivitySummaryEmail = 'ReceiveWeeklyActivitySummaryEmail',
  ReceiveNewsEmail = 'ReceiveNewsEmail',
  ReceiveMessageEmail = 'ReceiveMessageEmail',
  IsCCMyselfSetting = 'IsCCMyselfSetting',
}
